import React from "react";
import { Grid } from "@mui/material";
import { convertirLetraMayus } from "../../helpers/convertirLetraMayus";
import { useAreas } from '../../hooks/useAreas';
import { useGetRoles } from "../../hooks/useGetRoles";
import { useSedes } from "../../hooks/useSedes";
import { CustomInputText } from "../CustomInputText";
import { useForm, Controller } from 'react-hook-form';
import { CustomButtonsForm } from "../CustomButtonsForm";
import { CustomInputSelect } from "../CustomInputSelect";
import { CustomInputSwitch } from "../CustomInputSwitch";

export const UpdateUserForm = ({ data, action }) => {

    const { sedes } = useSedes();
    const { roles } = useGetRoles();
    const { areas } = useAreas();
    const { handleSubmit, control, formState: { errors } } = useForm();

    return (
        <form style={{ margin: '30px 30px 20px 30px', position: 'relative',  width: 420 }} onSubmit={handleSubmit(action)}>
            <Grid container>
                <Grid item xs={12}>
                    <CustomInputText 
                        label='Nombres y Apellidos'
                        value={ convertirLetraMayus(data?.nombre, true) ?? "" }
                        disabled={ true }
                    />
                </Grid>

                {/* CORREO */}
                <Grid item xs={12}>
                    <CustomInputText 
                        label='Correo electrónico'
                        value={ data?.correo ?? "" }
                        disabled={ true }
                    />
                </Grid>

                <Grid container spacing={2}>
                    {/* SEDE */}
                    <Grid item xs={12} lg={6}>
                        <Controller
                            name="sede"
                            control={control}
                            defaultValue={data?.sede._id || ""}
                            render={({ field: { onChange, value } }) => (
                                <CustomInputSelect
                                    label='Sede'
                                    options={sedes.map(a => ({ ...a, name: a?.nombre }))}
                                    onChange={ onChange }
                                    value={ value }
                                    error={ errors.sede }
                                />
                            )}
                            rules={{
                                required: "* Sede requerida.",
                            }}
                        />
                    </Grid>

                    {/* ROL */}
                    <Grid item xs={12} lg={6}>
                        <Controller
                            name="rol"
                            control={control}
                            defaultValue={data?.rol?._id || ""}
                            render={({ field: { onChange, value } }) => (
                                <CustomInputSelect
                                    label='Rol'
                                    options={roles.map(a => ({ ...a, name: a?.nombre }))}
                                    onChange={ onChange }
                                    value={ value }
                                    error={ errors.rol }
                                />
                            )}
                            rules={{
                                required: "* Rol requerido.",
                            }}
                        />
                    </Grid>
                </Grid>

                {/* AREA */}
                <Grid item xs={12}>
                    <Controller
                        name="area"
                        control={control}
                        defaultValue={data?.area?._id || ""}
                        render={({ field: { onChange, value } }) => (
                            <CustomInputSelect
                                label='Area'
                                options={areas.map(a => ({ ...a, name: a?.nombre }))}
                                onChange={ onChange }
                                value={ value }
                                error={ errors.area }
                            />
                        )}
                        rules={{
                            required: "* Area requerida.",
                        }}
                    />
                </Grid>
                
                <Grid container spacing={2}>
                    {/* USUARIO */}
                    <Grid item xs={12} lg={6}>
                        <CustomInputText 
                            label='Usuario'
                            value={ data?.username ?? "" }
                            disabled={ true }
                        />
                    </Grid>

                    {/* CONTRASEÑA */}
                    <Grid item xs={12} lg={6}>
                        <Controller
                            name="contrasena"
                            control={control}
                            defaultValue=""
                            render={({ field: { onChange, value } }) => (
                                <CustomInputText 
                                    label='Contraseña'
                                    onChange={ onChange }
                                    value={ value }
                                    placeholder='******'
                                    error={ errors.contrasena }
                                />
                            )}
                            rules={{
                                pattern: {
                                    value: /^[^\s]+[^\s]$/,
                                    message: "* Contraseña incorrecta",
                                },
                            }}
                        />
                    </Grid>
                </Grid> 

                {/* <Grid item xs={12}>
                    <Controller
                        name="autoriza_salida"
                        control={control}
                        defaultValue={data?.autoriza_salida ?? false}
                        render={({ field: { onChange, value } }) => (
                            <CustomInputSwitch 
                                label='¿Autoriza salida de activos?'
                                onChange={ onChange }
                                value={ value }
                            />
                        )}
                    />
                </Grid> */}
            </Grid>

            {/* <CustomButtonsForm name='Actualizar' /> */}
            <CustomButtonsForm name='Actualizar' style={{ position: 'sticky', bottom: 20 }} />
        </form>
    );
}